import React from 'react';
import PTButton from '../../../components/GenericComponents/PTButton';
import LeftLogo from '../../../components/LeftLogo';

export default function CheckEmail() {
  return (
    <div className="w-screen flex proptech-layout-wrapper flex-wrap">
      <div className="w-full md:w-3/5">
        <LeftLogo />
      </div>
      <div className="md:min-h-screen w-full md:w-2/5 items-center inline-flex relative">
        <div className="wrapper-container">
          <div className="text-wrapper">
            <h2>Check your email</h2>
            <p className='p-0'>If we have an account for this email address, you’ll receive an email with a reset link soon.</p>
          </div>
          <div className='pt-[20px]'>
            <PTButton
              label='Back to login'
              className="normal-case fill-orange btn"
              size='large'
              handleOnClickEvent={() => window.location.href = '/investor/login'}
            />
          </div>
          <div className="not-have-account">
            <span>
              Need a hand? Email our support team at
              <a href='mailto:admin@theproptechconnection.com' className='block'>
                admin@theproptechconnection.com
              </a>
            </span>
          </div>
        </div>

      </div>
    </div>)
}
